module.exports = __webpack_public_path__ + "static/media/background.8daf792f.jpg";